import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d47e984"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-expanded", "data-id"]
const _hoisted_2 = {
  key: 1,
  class: "ss-chevron-spacer"
}
const _hoisted_3 = ["checked", "disabled", "data-id"]
const _hoisted_4 = {
  key: 2,
  class: "ss-type"
}
const _hoisted_5 = {
  key: 3,
  class: "ss-flag ss-flag-args",
  title: 'This field requires arguments and can only be used via the Raw action.'
}
const _hoisted_6 = {
  key: 4,
  class: "ss-flag ss-flag-deprecated",
  title: 'Deprecated — not selectable here; use the Raw action if you must query it.'
}
const _hoisted_7 = {
  key: 5,
  class: "ss-flag ss-flag-recursive",
  title: 'Recursive type'
}
const _hoisted_8 = ["data-id"]
const _hoisted_9 = {
  key: 0,
  class: "ss-children"
}
const _hoisted_10 = {
  key: 0,
  class: "ss-note"
}
const _hoisted_11 = {
  key: 0,
  class: "ss-note"
}
const _hoisted_12 = ["data-id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectionSetTreeNode = _resolveComponent("SelectionSetTreeNode", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['ss-node', 'depth-' + _ctx.depth])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["ss-row", { 'ss-leaf': !_ctx.meta.expandable }])
    }, [
      (_ctx.meta.expandable)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: _normalizeClass(["ss-chevron", { opened: _ctx.open }]),
            "aria-expanded": _ctx.open ? 'true' : 'false',
            "data-id": 'ss-expand-' + _ctx.rowId,
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleOpen && _ctx.toggleOpen(...args)), ["stop"]))
          }, null, 10, _hoisted_1))
        : (_openBlock(), _createElementBlock("span", _hoisted_2)),
      _createElementVNode("input", {
        ref: "checkbox",
        type: "checkbox",
        class: "ss-checkbox",
        checked: _ctx.state.checked,
        disabled: _ctx.checkDisabled,
        "data-id": 'ss-check-' + _ctx.rowId,
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCheck && _ctx.onCheck(...args)))
      }, null, 40, _hoisted_3),
      _createElementVNode("span", {
        class: _normalizeClass(["ss-label", { 'ss-deprecated': _ctx.meta.deprecated }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.meta.expandable ? _ctx.toggleOpen() : _ctx.onLabelClick()))
      }, _toDisplayString(_ctx.label), 3),
      (_ctx.meta.expandable && !_ctx.meta.isRoot)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_ctx.typeLabel) + ")", 1))
        : _createCommentVNode("", true),
      (_ctx.meta.requiredArgs)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "args"))
        : _createCommentVNode("", true),
      (_ctx.meta.deprecated)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "deprecated"))
        : _createCommentVNode("", true),
      (_ctx.isRecursive)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "↻"))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", {
            key: 6,
            class: "ss-spinner",
            "data-id": 'ss-spinner-' + _ctx.rowId
          }, null, 8, _hoisted_8))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.depthExceeded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Maximum depth reached."))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child) => {
                  return (_openBlock(), _createBlock(_component_SelectionSetTreeNode, {
                    key: _ctx.childKey(child),
                    segments: [..._ctx.segments, _ctx.segmentOf(child)],
                    meta: child,
                    depth: _ctx.depth + 1,
                    "ancestor-types": [..._ctx.ancestorTypes, _ctx.childTypeName],
                    disabled: _ctx.disabled
                  }, null, 8, ["segments", "meta", "depth", "ancestor-types", "disabled"]))
                }), 128)),
                (_ctx.loaded && _ctx.children.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, " No selectable fields. "))
                  : _createCommentVNode("", true),
                (_ctx.loadError)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "ss-note ss-load-error",
                      "data-id": 'ss-load-error-' + _ctx.rowId
                    }, " Couldn’t load fields. Collapse and expand to retry. ", 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}